// extracted by css-extract-rspack-plugin
export default {"SavedEntityListRoot":"inRT8","SavedEntityListItem":"BCfDS","SavedEntityListItemIcon":"Y6ijk","LoadingWrapper":"gaEPS"};